import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Box, Typography, FormControl, Select, MenuItem, makeStyles} from '@material-ui/core';
import PlanningSiteLoadProfileChart from '@generic/pages/SitePlanner/PlanningSiteLoadProfileChart';

const useStyles = makeStyles(() => ({
  selectLabel: {
    marginRight: '1rem',
    lineHeight: '1.5rem',
  },
  select: {
    fontSize: '1rem',
    marginRight: '8px',
    fontWeight: 600,
    '& .MuiSelect-root': {
      paddingBottom: '4px',
    },
  },
}));

export default function PlanningSiteLoadProfile() {
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const timeRanges = [
    {value: 'month', display: formatMessage({id: 'timePeriods.labels.month'})},
    {value: 'day', display: formatMessage({id: 'timePeriods.labels.day'})},
    {value: 'hour', display: formatMessage({id: 'timePeriods.labels.hour'})},
  ];

  // Default to monthly view
  const [selectedTimeRange, setSelectedTimeRange] = useState(timeRanges[0]);

  const handleSelectChange = (e) => {
    const timeRange =
      timeRanges.find((range) => e.target.value === range.value) || timeRanges[7].value;
    setSelectedTimeRange(timeRange);
  };

  return (
    <Box mt={12}>
      <Typography variant="h6" align="center">
        {formatMessage({id: 'planning.content.electricity.loadProfile.header'})}
      </Typography>
      <Typography variant="body2" align="center">
        {formatMessage({id: 'planning.content.electricity.loadProfile.subheader'})}
      </Typography>
      <Box mt={3} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body2" className={classes.selectLabel}>
          <label htmlFor="load-profile-time-range">
            {formatMessage({id: 'planning.content.electricity.loadProfile.selectLabel'})}
          </label>
        </Typography>
        <FormControl>
          <Select
            className={classes.select}
            value={selectedTimeRange.value}
            onChange={handleSelectChange}
            inputProps={{id: 'load-profile-time-range'}}
          >
            {timeRanges.map((timeRange) => (
              <MenuItem key={timeRange.value} value={timeRange.value}>
                {timeRange.display}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <PlanningSiteLoadProfileChart timeRange={selectedTimeRange} />
    </Box>
  );
}
